import React from 'react'
import './User_SetNameState.css'
import '../UserPanel.css'

class User_WelcomeState extends React.Component{
    render() {
        let mainStyle = {
            "paddingTop":"100px",
            "paddingLeft":"100px",
            "width":"1400px",
            "height":"281px",
            "display":"flex",
            "flexDirection":"column",
            "justifyContent":"space-between",
            "alignItems":"flex-start"};
        return <div style={mainStyle}>
            <div className='user-header-text'>Приветствуем вас в игре <br />
                «Управление Железнодорожным Транспортом»</div>
            <div className='user-set-name-tooltip-container'>
                <div className='user-set-name-tooltip-text'>Подождите, пока преподаватель не начнет следующий этап</div>
            </div>
        </div>
    }
}

export default User_WelcomeState;
